import { RelatedIncidentItem} from "./RelatedIncidentItem";

export default RelatedIncidentItem;
